<template>
  <div>
      <div id="titolo"><font style="text-align:center; color:black; font-size:31px; font-weight:bold ">Locarno Film Festival - Disability Inclusion in the Audiovisual Industry</font></div>
      <div class="caption-join body">
          <div id="captions-text" class="caption">
              <div v-for="caption in captions" :key="caption.offset">{{ caption.text }}</div>
          </div>
      </div>
      <div style="text-align:left; padding-left:25px">
          <font style="font-size:45px; font-weight:bold">lix.ch/locarno</font>
      </div>
      <div id="language-select">
          <!--<input type="text" v-model="sessionName" placeholder="Session Name" style="width:120px;" value="Inclusion" />-->
          
              <!-- <img alt="Locarno Film Festival" src="@/assets/qr.png" style="width: 20%;" />-->
              
          
          <select v-model="toLanguageCode" style="width:60px;">
              <option v-for="lang in toLanguageCodes" :value="lang" :key="lang">
                  {{ lang }}
              </option>
          </select><br />

      </div>
   
      <div class="footer">
          <img style="width: 29%; margin-left: 20px; float:left" alt="Locarno Film Festival" src="@/assets/lff.png" />
          <img style="width: 18%; margin: 0 auto " alt="Microsoft" src="@/assets/microsoft-logo-png-transparent-20.png" />

          <img style="width: 16%; float: right; margin-right: 25px;" alt="Moresi.com" src="@/assets/logo-moresi-senza-zona-esclusione.png" />

          <center>Copyright by Moresi.com SA 2022 - Powered by Microsoft Azure Services - <a href="/credits">Credits</a></center>
      </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import constants from '../lib/constants'
import * as signalR from '@aspnet/signalr'
import languageListMixin from '../lib/language-list-mixin'

export default {
  mixins: [languageListMixin],
  props: {
    clientId: String
  },
  data() {
    return {
      code: '',
      captions: [],
      toLanguageCode: 'en',
        sessionName: 'Inclusion'
    }
  },
  computed: {
    toLanguageCodes() {
      return this.toLanguages.map(l => l.substring(0, 2)).sort()
    }
  },
  methods: {
    async updateLanguageSubscription(languageCode) {
      if (this.sessionName && languageCode) {

        await axios.post(`${constants.apiBaseUrl}/api/leave`, {
          userId: this.clientId,
        });

        await axios.post(`${constants.apiBaseUrl}/api/selectlanguage`, {
          languageCode,
          userId: this.clientId,
          sessionName: this.sessionName
        });
      }
    }
  },
  watch: {
    toLanguageCode: {
      handler() {
        return this.updateLanguageSubscription(this.toLanguageCode)
      },
      immediate: true
    },
    sessionName: {
      handler() {
        return this.updateLanguageSubscription(this.toLanguageCode)
      }
    }
  },
  async mounted() {
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(`${constants.apiBaseUrl}/api/${this.clientId}`)
      .build()

    this.connection.on('newCaption', onNewCaption.bind(this))

    await this.connection.start()
    console.log('connection started')

    const captionsMap = {}
    var final = false;
    function onNewCaption(caption) {
      console.log(caption);
      let localCaption = captionsMap[caption.offset]
      if (!localCaption) {
        localCaption = captionsMap[caption.offset] = {
          offset: caption.offset,
          text: ''
        }

        if (!final) {
          this.captions.pop();
        }

        if (caption.reason === "TranslatedSpeech") {
          this.captions.pop();
          final = true;
        }


          this.captions.push(localCaption)

          this.captions = this.captions.slice(-10);
      }
      localCaption.text = caption.text

      Vue.nextTick(function () {
        window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight)
      })
    }
  },
  async beforeDestroy() {
    if (this.connection) {
      await Promise.all([
        this.connection.stop(),
        this.updateLanguageSubscription(null)
      ])
      console.log('connection stopped')
    }
  }
}
</script>

<style scoped>
#language-select {
;
  top: 0;
  width: 100%;
  padding-top: 5px;
  padding-bottom: 6px;
  background-color: white;
}

#captions-text {
  padding-top: 140px;
  padding-bottom: 60px
}

.footer {
  height: 20%;
  margin-top: 2px;
  bottom: 0;
  padding: 10px;
}

.footer img {
  width: 20%;
}
    #nav {
        position: fixed;
        top: 15px;
        width: 100%;
        min-height: 50px;
        z-index: 1000;
        background-color: #fff;
    }
    #titolo {
        padding-top: 10px;
        padding-bottom: 10px;
        position: fixed;
        width: 100%;
        background-color: #FFDD00;
        opacity: 0.9;
        z-index: 1000;
        text-align: center;
        top: 0px;
        left: 0px;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    }
    .caption {
        margin: 28px auto;
        max-width: 1280px;
        font-size: 48px;
        text-align: left;
        padding: 24px;
    }
</style>
